// draft-merge-request-push-argv.ts
//
// Argv CỐ ĐỊNH của push candidate + Draft MR (P7 §7/D01, D02) — tách khỏi
// draft-merge-request-push.ts (V2-1 03b: file mẹ chạm trần 200 dòng khi thêm
// khối sổ quyết định E11 + redactor). Hàm thuần, không I/O.

/**
 * `source` (N-04): the commit pushed as the MR branch. Production passes the
 * candidate commit built by candidate-commit-without-controller-paths.ts —
 * the mission HEAD's tree minus `.claude/**`, parented on the base — never
 * the worktree HEAD itself, which tracks the pinned pack + settings.
 */
export function buildDraftMergeRequestPushArgv(input: {
  remote: string;
  branch: string;
  target: string;
  source?: string;
  /**
   * Round 3 M-A: the commit the branch is expected to hold (our last recorded
   * push to it). Adds `--force-with-lease=refs/heads/<branch>:<sha>` so a second
   * candidate (a sibling commit on the base) can replace the first — and only
   * while nobody else has moved the branch.
   */
  forceWithLeaseSha?: string;
}): string[] {
  return [
    "push",
    ...(input.forceWithLeaseSha === undefined
      ? []
      : [`--force-with-lease=refs/heads/${input.branch}:${input.forceWithLeaseSha}`]),
    "-o",
    "merge_request.create",
    "-o",
    "merge_request.draft",
    `-o`,
    `merge_request.target=${input.target}`,
    input.remote,
    `${input.source ?? "HEAD"}:refs/heads/${input.branch}`,
  ];
}
